<div class="rangebox">
    <button data-target="#collapsefreecancel" data-toggle="collapse" class="collapsebtn" type="button">Free Cancellation</button>
    <div id="collapsefreecancel" class="collapse show">
      <div class="boxins">
        <ul class="locationul">
          <li>
            <div class="squaredThree">
              <input
              type="checkbox"
              name="check"
              class="farecheckbox"
              id="squaredThree13"
              [(ngModel)]="isRefundable"
              (change)="onFilterChange()">
            <label for="squaredThree13"></label>
            </div>
            <label class="llbl" for="squaredThree13">Refundable</label>
          </li>
          <li>
            <div class="squaredThree">
              <input
              type="checkbox"
              name="check"
              class="farecheckbox"
              id="squaredThree14"
              [(ngModel)]="isNonRefundable"
              (change)="onFilterChange()">        
            <label for="squaredThree14"></label>
              <label for="squaredThree14"></label>
            </div>
            <label class="llbl" for="squaredThree14">Non Refundable</label>
          </li>
        </ul>
      </div>
    </div>
  </div>
  